/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Audience_Search_WordsInputs */



/**
* | output |
* | --- |
* | "presence, online, apps, activity by hour, segments, participation, inactive, account age" |
*
* @param {View_Audience_Search_WordsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const view_audience_search_words = /** @type {((inputs?: View_Audience_Search_WordsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Audience_Search_WordsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("статусы, в сети, приложения, активность по часам, сегменты, участие, неактивные, возраст аккаунта")
	return /** @type {LocalizedString} */ ("presence, online, apps, activity by hour, segments, participation, inactive, account age")
});